import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import api from '../../api/api';
import { Player, Team, Position, Match, Game, SimplePlayer, MatchWithRanks,Placing, PlacingWithCaptainVice, SCTeam, LightPlayer, PlacingWithChange, PartnerShip, SCTeamWithPlacings, PlayerOwnership } from '../../types/types';

export interface FrontState {
  frontData: {
    featuredPlayers: SimplePlayer[];
    players: Player[];
    teams: Team[];
    positions: Position[];
    topPlayers: Player[];
    lastMatches: Match[];
    toplastround: Game[];
    allplayers: SimplePlayer[];
    bestPlacings: PlacingWithCaptainVice[];
    lastRoundBestBatters: Player[];
    lastRoundBestBowlers: Player[];
    lastRoundBestTeam: {
      id: number;
      team: SCTeam;
      players: {
        player: LightPlayer;
        played: string;
        game: Game;
      }[]
    };
    lastRoundBestPlacing: PlacingWithChange;
    PositionPlayers: {
      players: Player[];
    }
    featuredTeam: {
      team: SCTeamWithPlacings;
      ownerships: PlayerOwnership[];
    },
    mostViewedPlayers: LightPlayer[];
  }
  singlePlayer: {
    player: Player;
    games: Game[];
    matches: Match[];
    upcoming: MatchWithRanks[];
    partnerShips: PartnerShip[];
    stats: {
      be: number;
      nv: number;
      last5: number[];
      three: number|string;
      five: number|string;
      avgpts: number;
      avgbase: number;
      aveppm: number;
    };
  }
  status: 'idle' | 'loading' | 'failed';
}

export interface action {
  type: String,
  payload: {teams: [], players: [], positions: [], topPlayers: [], lastMatches: [], toplastround: [], allplayers: [], PositionPlayers: {players: []}, bestPlacings: [], lastRoundBestTeam: {}, lastRoundBestPlacing: {},lastRoundBestBatters: [], lastRoundBestBowlers: []}
}

export interface SinglePlayerAction {
  player: Player; 
  games: Game[];
  matches: Match[];
  upcoming: MatchWithRanks[];
  partnerShips: PartnerShip[];
  stats: {
    be: number;
    nv: number;
    last5: number[];
    five: string|number;
    three: string|number;
    avgpts: number;
    avgbase: number;
    aveppm: number;
  };
}

export interface SinglePlayerPayload { 
  type: String,
  payload: { player: Player, games: Game[], stats: object}
}

export interface payloadAction { 
  teams: Team[];
  players: Player[];
  positions: Position[];
  topPlayers: Player[];
  lastMatches: Match[];
  toplastround: Game[];
  allplayers: SimplePlayer[];
  bestPlacings: PlacingWithCaptainVice[];
  lastRoundBestTeam: {
    id: number;
    team: SCTeam;
    players: {
      player: LightPlayer;
      played: string;
      game: Game;
    }[]
  };
  PositionPlayers: {players: Player[]}
  featuredTeam: { 
    team: SCTeamWithPlacings;
    ownerships: PlayerOwnership[];
  }
}

const initialState: FrontState = {
  frontData: { 
    players: [], 
    teams: [],
    positions: [],
    topPlayers: [],
    lastMatches: [],
    toplastround: [],
    allplayers: [],
    PositionPlayers: {players: []},
    bestPlacings: [],
    lastRoundBestTeam: {id: -1, team: {teamid: "1", name: ""}, players: []},
    lastRoundBestPlacing: {team: {teamid: "-1", name: ""}, round: -1, price: -1, price_change: 0,position:-1, round_position:-1, season:"2022" },
    featuredTeam: {team: null, ownerships: []}
  },
  singlePlayer: {
    player: {id: "-1", firstname: "", lastname: "", pic: '', position: {name: ""}, stats: [{last5Games: [], timestamp: "", avgpts: 0, avgbase:0, ppm: 0}], positionrank: [],ownerships: [], partnerShips: [], overs: [], positions: [], dismissals: []},
    games: [],
    matches: [],
    upcoming: [],
    stats: {
      be: -1,
      nv: -1,
      last5: [],
      three: -1,
      five: -1,
      avgpts: 0, 
      avgbase:0,
      aveppm: 0,
    }
  },
  status: "idle"
}

const fetchFront = () => {
  return new Promise<{ data: payloadAction}>((resolve) => {
    api.get('/front').then(function(payload) {
      console.log("Fetch front payload: ", payload);
      resolve(payload);
    });
  })
}

const fetchSinglePlayer = (id?:string) => {
  return new Promise<{data: SinglePlayerAction}>((resolve) => {
    api.get('/player/'+id).then(function(payload) {
      resolve(payload);
    });
  });
}

export const GetSinglePlayer = createAsyncThunk(
  'front/getsingleplayer',
  async (id?:string) => {
    const response = await fetchSinglePlayer(id);
    return response;
  }
)

export const getFront = createAsyncThunk(
  'front/getfront',
  async () => {
    const response = await fetchFront();
    return response;
  }
)


export const frontSlice = createSlice({
  name: "front",
  initialState,
  reducers: {
    getfront: (state, action: action) => {
      state.frontData = action.payload;
    },
    getsingleplayer: (state, action: action) => {

    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFront.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getFront.fulfilled, (state, action) => {
        state.status = 'idle';
        console.log("GETFRONTDATA: ", action.payload.data);
        state.frontData = action.payload.data;
      })
      .addCase(GetSinglePlayer.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(GetSinglePlayer.fulfilled, (state, action) => {
        state.status = 'idle';
        state.singlePlayer = action.payload.data
        console.log("action.payload.data: ", action.payload.data)
      });

  }
})

export const selectPlayers = (state: RootState) => state.front.frontData?.players;

export const selectPositions = (state: RootState) => state.front.frontData?.positions;

export const selectTeams = (state: RootState) => state.front.frontData?.teams;

export const selectFront = (state: RootState) => state.front;

export const selectTopPlayers = (state: RootState) => state.front.frontData.topPlayers;

export const selectLastMatches = (state: RootState) => state.front.frontData.lastMatches;

export const selectTopLastRound = (state: RootState) => state.front.frontData.toplastround;

export const selectLoadingStatus = (state: RootState) => state.front.status;

export const selectPlayer = ( id?: string) => (state: RootState) => state.front.frontData.players.filter(function(player: Player) {
  return player.id.toString() === id;
})

export const selectAllPlayersList = (state: RootState) => state.front.frontData.allplayers;

export const selectSinglePlayer = (state: RootState) => state.front.singlePlayer;

export const selectUpcoming = (state: RootState) => state.front.singlePlayer.upcoming;

export const selectTopPlayerPositions = (state: RootState) => state.front.frontData.PositionPlayers;

export const selectFrontData = (state: RootState) => state.front.frontData;

export const selectFeaturedTeam = (state: RootState) => state.front.frontData.featuredTeam;

export const { getfront } = frontSlice.actions

export default frontSlice.reducer;